module.exports = __webpack_public_path__ + "static/media/boy-on-ledge.3091b6c4.png";